import React, { useEffect, useState } from "react";
import { IonContent, IonPage, useIonToast } from "@ionic/react";
import { withRouter } from "react-router";
import { addOutline } from "ionicons/icons";

import {
  FechaDeGrupo,
  ReclamosDeTrabajoProps,
  RegistroReclamo,
} from "src/utils/interfaces";
import { filtrosActivosATexto } from "src/utils/especificos";
import {
  getMainScroll,
  getQueryParam,
  setMainScroll,
  setQueryParam,
} from "src/utils/domAndURLs";
import { compararFechas, conseguirFechasDeGrupos } from "src/utils/fechas";

import {ReclamosAPI} from "src/services/reclamos";

import Header from "src/components/Header";
import Reclamos from "src/components/Reclamos/Reclamos";
import FAB from "src/components/FloatingActionButton";

const ReclamosDeTrabajo: React.FC<ReclamosDeTrabajoProps> = (
  props: ReclamosDeTrabajoProps
) => {
  const [registros, setRegistros] = useState<RegistroReclamo[]>([]);
  const [fechasDeGrupos, setFechasDeGrupos] = useState<FechaDeGrupo[]>([]);
  const [present] = useIonToast();

  const previousHeight = parseInt(getQueryParam("previousHeight") ?? "0");

  useEffect(() => {
    const solicitarReclamos = () => {
      ReclamosAPI.listar(props.filtros).then(
        (nuevos) => {
          if (nuevos.length > 0) {
            nuevos.sort((a, b) => compararFechas(a.fecha, b.fecha)).reverse();
  
            const grupos = conseguirFechasDeGrupos(nuevos);
  
            setFechasDeGrupos(grupos);
            setRegistros(nuevos);
          } else {
            setFechasDeGrupos([]);
            setRegistros([]);
  
            present({
              message:
                "No se encontraron reclamos. No se cargan reclamos del mes",
              duration: 5000,
            });
          }
        },
        (error) => {
          present({
            message: error.response ? error.response.data.Error : error,
            duration: 5000,
          });
        }
      )
    };
    solicitarReclamos()
    return () => {};
  }, [props.filtros, present]);

  useEffect(() => {
    if (previousHeight) setMainScroll(previousHeight);
  }, [previousHeight, registros]);

  

  const agregarReclamo = () => {
    const alturaActual = getMainScroll() ?? 0;
    const newURL = setQueryParam("previousHeight", alturaActual);
    const urlSinHost = `${newURL.pathname}${newURL.search}`;
    props.history.push(urlSinHost);

    const linkReclamo = `/reclamos/procesar?pageFrom=${props.location.pathname}`;
    props.history.push(linkReclamo);
  };

  const irAFiltros = () => {
    const alturaActual = getMainScroll() ?? 0;
    const newURL = setQueryParam("previousHeight", alturaActual);
    const urlSinHost = `${newURL.pathname}${newURL.search}`;
    props.history.push(urlSinHost);

    props.history.push("/reclamos/filtros");
  };

  const filtrosActivos = props.filtros
    ? filtrosActivosATexto(props.filtros)
    : "";

  const botonFiltrar = {
    src: "assets/icon/filter.svg",
    action: irAFiltros,
  };

  return (
    <IonPage>
      <Header titulo="Reclamos de Trabajo" botonesDerecha={[botonFiltrar]} />

      <IonContent id="reclamos">
        <div className="container mb-4">
          <div className="active-filtros">
            <p className="m-0 py-1">{filtrosActivos}</p>
          </div>

          <Reclamos
            registros={registros}
            fechasDeGrupos={fechasDeGrupos}
            cargo={props.cargo}
          />

          <FAB icon={addOutline} handleClick={agregarReclamo} />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(ReclamosDeTrabajo);
